import { CashRequestOptions, post } from '@cash-web/shared-util-fetch'
import { GetScenarioPlanRequest } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'
import { GetScenarioPlanResponse } from '@cash-web/shared-util-protos/squareup/franklin/app.pb'

export const getScenarioPlan = (request: GetScenarioPlanRequest, options?: CashRequestOptions) =>
  post<GetScenarioPlanRequest, GetScenarioPlanResponse>('/2.0/cash/get-scenario-plan', request, {
    ...options,
    rejectOnError: true,
  })
